import DefaultLayout from "@/layouts/DefaultLayout/DefaultLayout.vue"

import accountManageRoutes from "./modules/accountManage"
import audiencesRoutes from "./modules/audiences"
import authRoutes from "./modules/auth"
import automatedMarketingRoutes from "./modules/automatedMarketing"
import commonRoutes from "./modules/common"
import dataManage from "./modules/dataManage"
import marketing from "./modules/marketing"
import marketingResources from "./modules/marketingResources"
import notificationCenter from "./modules/notificationCenter"
import platformSettings from "./modules/platformSettings"

import PERMISSIONS from "@/utils/permissions/index.js"

const routes = [
    {
        path: "/",
        name: "home",
        meta: {
            requiresAuth: true,
        },
    },
    ...authRoutes,
    ...commonRoutes,
    ...dataManage,
    ...audiencesRoutes,
    ...automatedMarketingRoutes,
    ...marketing,
    ...marketingResources,
    {
        name: "data-market",
        path: "/data-market",
        component: DefaultLayout,
        redirect: () => {
            return { name: "data-market-index" }
        },
        meta: {
            isShow: true,
            name: "數據市集",
            index: "6",
            position: "left",
            menuGroup: "map-test",
            permissions: [PERMISSIONS.VIEW_DASHBOARD],
        },
        children: [
            {
                path: "", // 數據市集（iframe 嵌入）
                name: "data-market-index",
                component: () => import("@/../DataMarket/DataMarket.vue"),
                meta: {
                    requiresAuth: true,
                    permissions: [PERMISSIONS.VIEW_DASHBOARD],
                    isSubShow: true,
                    subIndex: "6-1",
                    subGroup: "partner-portal",
                    subGroupName: "數據市集",
                    hasSubMenuGroup: false,
                    subMenuGroupIndex: "6",
                },
            },
            {
                path: "marketing",
                name: "data-market-marketing",
                component: () => import("@/../DataMarket/Marketing.vue"),
                meta: {
                    requiresAuth: true,
                    permissions: [PERMISSIONS.VIEW_DASHBOARD],
                    isSubShow: true,
                    subIndex: "6-2",
                    subGroup: "partner-portal",
                    subGroupName: "行銷",
                    hasSubMenuGroup: false,
                    subMenuGroupIndex: "6",
                },
            },
        ],
    },
    ...accountManageRoutes,
    ...platformSettings,
    ...notificationCenter,
    {
        path: "/about",
        name: "About",
        component: () => import("@/pages/About.vue"),
    },
    {
        path: "/redirect/:id",
        name: "redirect",
        component: DefaultLayout,
        meta: {
            requiresAuth: true,
        },
        children: [
            {
                path: "",
                component: () => import("@/pages/RedirectPage.vue"),
                name: "redirect-index",
            },
        ],
    },
    {
        path: "/forbidden",
        name: "forbidden",
        component: DefaultLayout,
        meta: {
            requiresAuth: true,
        },
        children: [
            {
                path: "",
                component: () => import("@/pages/ForbiddenPage.vue"),
                name: "forbidden-index",
            },
        ],
    },
    {
        path: "/:pathMatch(.*)*",
        component: DefaultLayout,
        meta: {
            requiresAuth: true,
        },
        children: [
            {
                path: "",
                component: () => import("@/pages/NotFoundPage.vue"),
                name: "not-found",
            },
        ],
    },
]

export default routes
